import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { HomeCardsImg } from "@/assets"
import { useModals } from "@/modals"
import { useAppDispatch, useAppSelector } from "@/store"
import { FindMatchSelectors, setFindMatchMode } from "@/store/slices/findMatch"
import { HomeMenuItem, IFindMatch } from ".."
import styles from "./FindMatch.module.scss"

export const FindMatch: FC<IFindMatch> = ({ className, ...rest }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { openModal } = useModals()

  const isMatchSearching = useAppSelector(
    FindMatchSelectors.selectFindMatchIsSearching()
  )

  const handleFindMatch = () => {
    dispatch(setFindMatchMode("modal"))
    openModal("findMatch")
  }

  return (
    <HomeMenuItem
      className={clsx(styles.FindMatch, className)}
      classNameContent={clsx(styles.FindMatch_content)}
      {...rest}
      title={t("findMatch.title")}
      button={{
        title: t("findMatch.title"),
        styles: "orange-3d",
        onClick: handleFindMatch,
        disabled: isMatchSearching
      }}
    >
      {t("findMatch.text")}
      <div className={clsx(styles.FindMatch_img)}>
        <img src={HomeCardsImg} alt="home cards" />
      </div>
    </HomeMenuItem>
  )
}
